/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EnforcementSignalSkuEnum } from './enforcementSignalSkuEnum';
import { DataCentersEnum } from './dataCentersEnum';


export interface SignalDataSelection { 
    sku?: EnforcementSignalSkuEnum;
    datacenter?: DataCentersEnum;
    used?: number;
    subscribed?: number;
}
export namespace SignalDataSelection {
}


